export default store => next => action => {

  if (action && action.error && action.error instanceof Error) {
    const error = action.error;

    if (error.status === 400 && error.content) {
      // do nothing
    }
    else if (error.status === 401 && error.code === 'LOGIN_FAILED') {
      //message.error(i18n.t('error-invalid-credentials'));
    }
    else if (error.status === 401) {
      store.dispatch({type: 'LOGOUT.REQUEST'});
      //message.error(i18n.t('error-session-expired'));
      //store.dispatch(logout());
    }
    else if (error.status === 503) {
      //message.error(i18n.t('error-server-unavailable'));
    }
    else {
      //message.error(i18n.t(action.payload.code));
    }
  }

  return next(action);
}



// WEBPACK FOOTER //
// ./src/services/ApiError.js